import { render } from "./FancyNumber.vue?vue&type=template&id=3a676916"
import script from "./FancyNumber.vue?vue&type=script&lang=js"
export * from "./FancyNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__